
import React, { useState, useEffect, useCallback, useRef ,useContext} from 'react';
import { useHistory } from 'react-router-dom';
import {
  TabMenuContainer, EmptySettingsDetails, TabSearchContainer, PopoverContainer,
  ClearAll,
  NoteText,
  TabMenuHeaderContainer,
  TabMenuItemContainer,
  SearchNavWrapper,
  TabMenuHeader,
  DropdownDetails,
  HelpGuideWrapper,
  LoaderContainer,
  NoDataView
} from '../../containers/SidebarMenu/styles';
import Loader from '../../components/Loader';
import ComplexPreviewModal from '../../components/Modals/ComplexPreviewModal';
import DeleteTemplateModal from '../../components/Modals/DeleteTemplateModal';
import CreateFlowModal from '../../components/CreateNewTemplate/CreateFlowModal';
import CreateBlockModal from '../../components/CreateNewTemplate/CreateBlockModal';
import { getFlowByCategory, fetchStandaloneFlow, fetchManageTags, getAllBlockByCategories, fetchStandaloneBlock } from '../../utils/services/complexDocumentsAPI';
import EmptyElementsIllustration from '../../images/empty-elements.svg';
import { withTranslation } from 'react-i18next';
import { DESIGN_AREA_FLOW_BLOCK_TAB } from '../../containers/SidebarMenu/translationValues';
import { FilterSvg } from '../../components/SidebarMenuIcons';
import EditorElement from '../../components/EditorElement';
import AddTagsModal from '../../components/Modals/AddTagsModal';
import { useArtboardContext, CONTEXT_KEYS } from '../../context/complexArtboardContext';
import { AppStoreContext } from '../../context/appStoreContext';
import {
  Icon,
  Menu,
  Dropdown,
  Col,
  Input,
  Popover,
  Select,
  Button,
  Badge,
  Tabs,
  message
} from 'antd';
import { REUSABLE_SECTION, REUSABLE_FLOW } from '../../utils/complexDocumentConstants';
import { UploadInserts } from './ComplexPdfInserts/UploadInserts';
import { ENTERPRISE_ENV } from '../../utils/helper';
import { fetchOrganizationInserts } from '../../utils/services/insertsApi';
import { ReuseInsertsTab } from './ComplexPdfInserts/ReuseInsertsTab';
import { fetchPublishedBlock, getPublishBlockByCategory } from '../../utils/services/interactiveDesignApi';

const NAMESPACES = ['DESIGN_AREA_FLOW_BLOCK_TAB'];
const { TabPane } = Tabs;
const { Option } = Select;

const ComplexElementsTab = props => {
  const { t } = props;
  let history = useHistory();
  const tagList = useRef();

  const [selectedView, setSelectedView] = useState('view-templates');
  const [selectedTab, setSelectedTab] = useState('flow');
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [fetchingCategories, setFetchingCategories] = useState(true);
  const [updateModalVisibility, setUpdateModalVisibility] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState();
  const [loadMore, setLoadMore] = useState(false);
  const [page, setPage] = useState(1);
  const [defaultTemplates, setDefaultTemplates] = useState([]);
  const [allInserts, setAllInserts] = useState([]);
  const [searchKey, setSearchKey] = useState('');
  const [searchedTemplates, setSearchedTemplates] = useState({});
  const [noData, setNodata] = useState(false);
  const [filterVisible, setFilterVisible] = useState(false);
  const [filterOption, setFilterOption] = useState('All');
  const [categoryTemplates, setCategoryTemplates] = useState([]);
  const [isBottom, setIsBottom] = useState(true);
  const [isLoading,setIsLoading] = useState(true);

  const currentDesignSelector = useCallback((store) => store[CONTEXT_KEYS.CURRENT_DESIGN], []);
  const [currentDesign] = useArtboardContext(currentDesignSelector, '');

  const interactiveDesignSelector = useCallback(store => store[CONTEXT_KEYS.IS_INTERACTIVE_DESIGN], []);
  const [isInteractiveDesign] = useArtboardContext(interactiveDesignSelector, `ComplexElementsTab`);

  const { checkUserAccess, checkUserAccessRoles } = useContext(AppStoreContext);

  useEffect(() => {
    if (isBottom && !loadMore && !noData) {
      if (selectedView === 'view-search-template') {
        onSearch();
      }
    }
    setDefaultTemplates(categoryTemplates);
    // eslint-disable-next-line
  }, [isBottom, categoryTemplates]);

  const onScroll = e => {
    if (!setIsBottom) return;
    const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;
    if (Math.abs(scrollTop + clientHeight - scrollHeight) < 10) {
      setIsBottom(true);
    } else {
      setIsBottom(false);
    }
  };

  const onClose = () => {
    setSearchKey('');
    if (!selectedCategory) {
      updateSelectedView('view-templates', null);
    } else {
      onSearch(true, undefined, '');
    }
  };

  const seeAllByCategory = category => {
    if (category === 'All') {
      updateSelectedView('view-templates', null);
    } else {
      setSelectedCategory(category);
      onSearch(true, category);
    }
  };

  const updateSelectedView = (view, templateObj) => {
    if (view === 'view-templates') {
      setSearchKey('');
      setFilterOption('All');
      setSelectedCategory(undefined);
      setSearchedTemplates({});
    }
    setSelectedView(view);
    setSelectedTab(templateObj);
    handleTemplateType(selectedTab)
  };

  const onSearch = async (first = false, category = selectedCategory, searchParam = searchKey) => {
    let currentPage = page;
    if (first) {
      setPage(1);
      currentPage = 1;
      setNodata(false);
      setFetchingCategories(true);
    }
    const payload = {
      name: searchParam || undefined,
      categoryId: category?.categoryId || undefined,
    };
    if (searchParam !== '') {
      payload.searchParam = searchKey || undefined;
    }
    setSelectedView('view-search-template');
    setLoadMore(true);
    setFilterOption(category);
    let response
    if (selectedTab === 'flow') {
      response = await fetchStandaloneFlow(payload);
    } else if (selectedTab === 'block') {
      if (isInteractiveDesign) {
        payload.designType = "content";
        payload.includeData = true;
        response = await fetchPublishedBlock(payload);
      } else {
        response = await fetchStandaloneBlock(payload);
      }
    } else if (selectedTab === 'inserts') {
      response = await fetchOrganizationInserts(payload);
    }
    const statusCode = [2605, 2505, 129];
    if (statusCode.includes(response?.statusCode)) {
      let templates = response.data;
      if (isInteractiveDesign) {
        templates = templates.map(item => {
          const {blockId, blockName, blockDTOList, ...rest} = item;
          return {
            ...rest,
            blocks: blockDTOList,
            parentBlockId: blockId,
            parentBlockName: blockName,
          }
        })
      }
      let updatedSearchTemplates = {
        count: response.dataCount,
        templates: first ? templates : [...searchedTemplates?.templates, ...templates],
      };
      setSearchedTemplates(updatedSearchTemplates);
      if (payload.limit * currentPage >= response.dataCount) {
        setNodata(true);
      }
      setPage(currentPage + 1);
    } else {
      message.warn(t(
        DESIGN_AREA_FLOW_BLOCK_TAB.FAILED_TO_PERFORM_ERROR_MESSAGE.key,
        DESIGN_AREA_FLOW_BLOCK_TAB.FAILED_TO_PERFORM_ERROR_MESSAGE.value,
      ));
    }
    setFetchingCategories(false);
    setLoadMore(false);
  };

  const fetchAllFlowByCategory = async () => {
    const response = await getFlowByCategory(4);
    if (response.statusCode === 2608) {
      setIsLoading(false)
      setCategoryTemplates(response?.data);
      setDefaultTemplates(response?.data)
    }
    else {
      message.warn(t(
        DESIGN_AREA_FLOW_BLOCK_TAB.FAILED_TO_PERFORM_ERROR_MESSAGE.key,
        DESIGN_AREA_FLOW_BLOCK_TAB.FAILED_TO_PERFORM_ERROR_MESSAGE.value,
      ));
    }
    setFetchingCategories(false);
  }

  const fetchAllBlockByCategory = async () => {
    let response;
    try {
      if (isInteractiveDesign) {
        const payload = {
          includeData: true,
          countPerCategory: 4,
          designType : "content"
        };
        response = await getPublishBlockByCategory(payload);
        if (response.statusCode === 2505) {
          const transformedArray = response.data.map(item => {
            const { blockDTOList, ...rest } = item;
            return {
              ...rest,
              standaloneBlocks: item.blockDTOList.map(item2 => {
                const { blockDTOList, blockName, blockId, ...rest } = item2;
                return {
                  ...rest,
                  blocks: blockDTOList,
                  parentBlockName: blockName,
                  parentBlockId: blockId,
                };
              })
            };
          });
          setIsLoading(false);
          setCategoryTemplates(transformedArray);
          setDefaultTemplates(transformedArray);
        } else {
          message.warn(t(
            DESIGN_AREA_FLOW_BLOCK_TAB.FAILED_TO_PERFORM_ERROR_MESSAGE.key,
            DESIGN_AREA_FLOW_BLOCK_TAB.FAILED_TO_PERFORM_ERROR_MESSAGE.value,
          ));
        }
      } else {
        response = await getAllBlockByCategories(4);

        if (response.statusCode === 2608) {
          setIsLoading(false);
          setCategoryTemplates(response?.data);
          setDefaultTemplates(response?.data);
        } else {
          message.warn(t(
            DESIGN_AREA_FLOW_BLOCK_TAB.FAILED_TO_PERFORM_ERROR_MESSAGE.key,
            DESIGN_AREA_FLOW_BLOCK_TAB.FAILED_TO_PERFORM_ERROR_MESSAGE.value,
          ));
        }
      }
    } catch (error) {
      message.warn(t(
        DESIGN_AREA_FLOW_BLOCK_TAB.FAILED_TO_PERFORM_ERROR_MESSAGE.key,
        DESIGN_AREA_FLOW_BLOCK_TAB.FAILED_TO_PERFORM_ERROR_MESSAGE.value,
      ));
    } finally {
      setFetchingCategories(false);
    }
  };

  const fetchAllInserts = async () => {
    setCategoryTemplates([]);
    setDefaultTemplates([]);
    setFetchingCategories(false);
    try {
      const response = await fetchOrganizationInserts();
      if (response?.statusCode === 129 && response?.data) {
        setAllInserts(response.data);
      } else {
        message.warn(
          t(
            DESIGN_AREA_FLOW_BLOCK_TAB.FAILED_TO_PERFORM_ERROR_MESSAGE.key,
            DESIGN_AREA_FLOW_BLOCK_TAB.FAILED_TO_PERFORM_ERROR_MESSAGE.value,
          ),
        );
      }
    } catch (e) {
      message.warn(
        t(
          DESIGN_AREA_FLOW_BLOCK_TAB.FAILED_TO_PERFORM_ERROR_MESSAGE.key,
          DESIGN_AREA_FLOW_BLOCK_TAB.FAILED_TO_PERFORM_ERROR_MESSAGE.value,
        ),
      );
    }
  };

  useEffect(() => {
    (async () => {
      if (isInteractiveDesign) {
        handleTemplateType('block');
      } else {
        handleTemplateType(['flow', 'block'].includes(currentDesign) ? "block" : 'flow');
      }
    })();
  }, []);

  const renderEmptyView = () => (
    <EmptySettingsDetails>
      <div className="empty-illustration">
        <img src={EmptyElementsIllustration} alt="EmptyElementsIllustration" />
      </div>
      <div className="empty-txt">
        <span>
          {t(
            DESIGN_AREA_FLOW_BLOCK_TAB.TEMPLATES_LIST_EMPTY.key,
            DESIGN_AREA_FLOW_BLOCK_TAB.TEMPLATES_LIST_EMPTY.value,
          )}
        </span>
      </div>
    </EmptySettingsDetails>
  );

  const redirectToStandaloneFlow = (template) => {
    if (template) {
      history.push(`/flow/${template}`);
    }
    onSuccess();
    window.location.reload();
  };

  const redirectToStandaloneBlock = (id) => {
    if (id) {
      history.push(`/block/${id}`);
    }
    onSuccess();
    window.location.reload();
  }

  const onSuccess = () => {
    setSelectedView('view-templates');
    setUpdateModalVisibility(false);
    selectedTab === 'flow' ? fetchAllFlowByCategory() : selectedTab === 'inserts' ? fetchAllInserts() : fetchAllBlockByCategory();
  };

  const renderModals = () => {
    switch (selectedAction) {
      case 'create-flow':
        return (
          <CreateFlowModal
            onSucess={redirectToStandaloneFlow}
            onCancel={disableModalVisibility}
            visible={updateModalVisibility}
          />
        );
      case 'create-reusableBlock':
        return (
          <CreateBlockModal
            onSucess={redirectToStandaloneBlock}
            onCancel={disableModalVisibility}
            visible={updateModalVisibility}
          />
        );
      case 'delete-template':
        return (
          <DeleteTemplateModal
            visible={updateModalVisibility}
            onCancel={disableModalVisibility}
            targetTemplate={selectedTemplate}
            TemplateType={selectedTab}
            onSucess={onSuccess}
          />
        );
      case 'add-tag':
        return (
          <AddTagsModal
            visible={updateModalVisibility}
            onCancel={disableModalVisibility}
            target={{ id: selectedTemplate.id, elementType: selectedTab, tags: tagList.current }}
            isFlow={true} />
        );
      case 'preview-thumbnail':
        return (
          <ComplexPreviewModal
            visible={updateModalVisibility}
            onCancel={disableModalVisibility}
            type={selectedTab}
            templateId={selectedTemplate?.id || selectedTemplate?.parentBlockId}       
            reusableFlow = {true}    
          />
        );

      default:
        break;
    }
  };

  const enableModalVisibility = async (actionType, template) => {
    setUpdateModalVisibility(true);
    setSelectedTemplate(template);
    setSelectedAction(actionType);

    if (actionType === "open_addTag_modal") {
      const payload = { id: template.id, type: selectedTab }
      const fetchTagsResponse = await fetchManageTags(payload);
      if (fetchTagsResponse?.statusCode === 1901) {
        tagList.current = fetchTagsResponse.data.tags;
        setSelectedAction("add-tag");
      }
      else {
        message.error(t(DESIGN_AREA_FLOW_BLOCK_TAB.FETCHING_RECORDS_ERROR_MESSAGE.key, DESIGN_AREA_FLOW_BLOCK_TAB.FETCHING_RECORDS_ERROR_MESSAGE.value))
      }
    }
  };

  const handleTemplateType = async (key) => {
    setSelectedTab(key);
    setSearchKey('');
    setFilterOption('All')
    setSelectedView('view-templates');
    setSearchedTemplates({});
    setCategoryTemplates([]);
    setDefaultTemplates([]);
    setAllInserts([]);
    setIsLoading(true)
    setFetchingCategories(true)
    if (key === 'block') {
      await fetchAllBlockByCategory()
    } else if (key === 'flow') {
      await fetchAllFlowByCategory()
    } else if (key === 'inserts') {
      fetchAllInserts();
    }
  };

  const previewModalVisibility = (e, actionType, template, pageId) => {
    e.stopPropagation();
    setUpdateModalVisibility(true);
    setSelectedAction(actionType);
    setSelectedTemplate(template);
  };

  const renderDropDown = (templateObj) => {
    return (
      <DropdownDetails
        id={`${templateObj.id}-template`}
        className="dropdown-menu"
        onClick={e => e.stopPropagation()}
      >
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item
                key="1"
                onClick={() =>
                  enableModalVisibility('delete-template', templateObj)
                }
              >
                {t(DESIGN_AREA_FLOW_BLOCK_TAB.TEMPLATE_DELETE_DROPDOWN_OPTION.key, DESIGN_AREA_FLOW_BLOCK_TAB.TEMPLATE_DELETE_DROPDOWN_OPTION.value)}
              </Menu.Item>
              <Menu.Item
                key="2"
                onClick={() => enableModalVisibility('open_addTag_modal', templateObj)}
              >
                {t(DESIGN_AREA_FLOW_BLOCK_TAB.TEMPLATE_MANAGE_TAGS_DROPDOWN_OPTION.key, DESIGN_AREA_FLOW_BLOCK_TAB.TEMPLATE_MANAGE_TAGS_DROPDOWN_OPTION.value)}
              </Menu.Item>
            </Menu>
          }
          trigger={['click']}
          overlayClassName='complex-elements-tab-dropdown'
        >
          <Icon type="more" />
        </Dropdown>
      </DropdownDetails>
    )
  }

  const singleTemplate = (category, templateObj, action) => {
    let categoryByTemplate = {
      id: templateObj.id || templateObj.parentBlockId,
      name: templateObj.flowName || templateObj.parentBlockName,
      categoryName: category?.categoryName,
      categoryId: category?.categoryId,
      tags: templateObj.tags,
      targetTemplate: templateObj.flow
    };

    let pageDetails = {
      language: templateObj?.language,
      thumbnail: templateObj?.thumbnail,
      elementDetails: templateObj.flow || templateObj.blocks,
      isTemplate: true,
      name: templateObj.flowName || templateObj.parentBlockName,
      id: templateObj.id || templateObj.parentBlockId,
      ...(templateObj?.type && {sectionType: templateObj.type}),
      ...(templateObj?.style && {style: templateObj.style}),
      ...(templateObj?.variableContractDTOS && {variableContract: templateObj.variableContractDTOS})
    };
    return (
      <EditorElement
        element={pageDetails}
        setIsDragAndDropped={() => { }}
        clickElement={() => { }}
        toggleDragging={() => { }}
        type={templateObj.id ? REUSABLE_FLOW : templateObj.type === 'content' ? REUSABLE_SECTION : templateObj.type}
        cardType={'reusableTemplate'}
        renderDropDown={() => (isInteractiveDesign && selectedTab === 'block') || !checkUserAccessRoles(['REUSABLECONTENTMANAGER']) ? null : renderDropDown(categoryByTemplate)}
        onPreviewClick={(e) => previewModalVisibility(e, 'preview-thumbnail', templateObj)}
      />
    );
  };

  const tabHeaderView = category => {
    const template = selectedTab === "flow" ? category.standaloneFlows : category.standaloneBlocks;
    return (
      <Col>
        <TabMenuHeader inverted={0} className={'categoryName'}><h2>{category.categoryName}</h2></TabMenuHeader>
        {template?.length >= 4 && (
          <TabMenuHeader inverted={0} onClick={() => seeAllByCategory(category)}>
            <div className='see-all'>{t(DESIGN_AREA_FLOW_BLOCK_TAB.SEE_ALL_TEMPLATES_ACTION.key, DESIGN_AREA_FLOW_BLOCK_TAB.SEE_ALL_TEMPLATES_ACTION.value)}</div>
          </TabMenuHeader>
        )}
      </Col>
    );
  };

  const templateCardView = (category, action) => {
    const template = selectedTab === "flow" ? category.standaloneFlows : category.standaloneBlocks;
    return template?.length > 0 ? (
      <TabMenuItemContainer>
        {template.map(templateObj => {
          return singleTemplate(category, templateObj, action);
        })}
      </TabMenuItemContainer>
    ) : (
      <div></div>
    );
  };


  const showMoreView = text => {
    const loaderStyles = { top: '0px' };
    return (
      <>
        {loadMore && renderLoader(loaderStyles)}
        {noData && <NoDataView small>{text}</NoDataView>}
      </>
    );
  };

  const renderSearchView = () => {
    return searchedTemplates.templates?.length > 0 ? (
      <>
        <TabMenuItemContainer>
          {selectedTab === 'inserts' ? <ReuseInsertsTab inserts={searchedTemplates.templates} onSuccess={onSuccess}/> : searchedTemplates.templates.map(data => {
            const categoryDetails = {
              categoryId: data.categoryId,
            };
            return singleTemplate(categoryDetails, data, 'view-search-template');
          })}
        </TabMenuItemContainer>
        {showMoreView(t(DESIGN_AREA_FLOW_BLOCK_TAB.GOT_ALL_RESULTS.key, DESIGN_AREA_FLOW_BLOCK_TAB.GOT_ALL_RESULTS.value))}
      </>
    ) : (
      <NoDataView>{t(DESIGN_AREA_FLOW_BLOCK_TAB.NO_TEMPLATES_AVAILABLE.key, DESIGN_AREA_FLOW_BLOCK_TAB.NO_TEMPLATES_AVAILABLE.value)}</NoDataView>
    );
  };

  const renderCategory = () => {
    return (
      <>
        {categoryTemplates.map(category => (
          <TabMenuHeaderContainer key={category.categoryId}>
            {tabHeaderView(category)}
            {templateCardView(category, 'view-templates')}
          </TabMenuHeaderContainer>
        ))}
      </>
    );
  };

  const renderTabBody = () => {
    switch (selectedView) {
      case 'view-templates':
        if (selectedTab === 'inserts') {
          return <ReuseInsertsTab inserts={allInserts} onSuccess={onSuccess}/>;
        }
        return renderCategory();
      case 'view-search-template':
        return renderSearchView();
      default:
        break;
    }
  };

  const renderSearchBar = () => {
    return (
      <TabSearchContainer Master={checkUserAccess('master')} marginTop>
        <Input
          name="templateSearch"
          placeholder={
            selectedTab === 'inserts'
              ? t(
                  DESIGN_AREA_FLOW_BLOCK_TAB.SEARCH_INSERTS_PLACEHOLDER.key,
                  DESIGN_AREA_FLOW_BLOCK_TAB.SEARCH_INSERTS_PLACEHOLDER.value,
                )
              : t(
                  DESIGN_AREA_FLOW_BLOCK_TAB.SEARCH_TEMPLATES_PLACEHOLDER.key,
                  DESIGN_AREA_FLOW_BLOCK_TAB.SEARCH_TEMPLATES_PLACEHOLDER.value,
                )
          }
          value={searchKey}
          onChange={e => setSearchKey(e.target.value)}
          onPressEnter={() => onSearch(true)}
          style={{ width: 200 }}
          prefix={<Icon type="search" />}
          autoComplete={'off'}
          suffix={
            <>
              {searchKey.length > 0 && <Icon type="close" onClick={onClose} />}
              {selectedTab !== 'inserts' ? (<Popover
                placement="bottomRight"
                title={t(
                  DESIGN_AREA_FLOW_BLOCK_TAB.SEARCH_BY_CATEGORY_LABEL.key,
                  DESIGN_AREA_FLOW_BLOCK_TAB.SEARCH_BY_CATEGORY_LABEL.value,
                )}
                trigger="click"
                visible={filterVisible}
                onVisibleChange={() => setFilterVisible(!filterVisible)}
                content={
                  <PopoverContainer>
                    <ClearAll
                      onClick={() => [
                        setFilterVisible(false),
                        updateSelectedView('view-templates', null),
                      ]}
                    >
                      {t(
                        DESIGN_AREA_FLOW_BLOCK_TAB.CLEAR_ALL_FILTER_ACTION.key,
                        DESIGN_AREA_FLOW_BLOCK_TAB.CLEAR_ALL_FILTER_ACTION.value,
                      )}
                    </ClearAll>
                    <Select
                      showSearch
                      value={JSON.stringify(filterOption)}
                      style={{ width: 200 }}
                      placeholder="Select Category"
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      onChange={value => setFilterOption(JSON.parse(value))}
                    >
                      <Option key="all" value={JSON.stringify('All')}>
                        {t(
                          DESIGN_AREA_FLOW_BLOCK_TAB.ALL_CATEGORY_DROPDOWN_OPTION.key,
                          DESIGN_AREA_FLOW_BLOCK_TAB.ALL_CATEGORY_DROPDOWN_OPTION.value,
                        )}
                      </Option>
                      {defaultTemplates?.length > 0 &&
                        defaultTemplates.map(data => (
                          <Option key={data.categoryId} value={JSON.stringify(data)}>
                            {data.categoryName}
                          </Option>
                        ))}
                    </Select>
                    <Button
                      type="primary"
                      onClick={() => [setFilterVisible(false), seeAllByCategory(filterOption)]}
                    >
                      {t(
                        DESIGN_AREA_FLOW_BLOCK_TAB.APPLY_FILTERS_BUTTON.key,
                        DESIGN_AREA_FLOW_BLOCK_TAB.APPLY_FILTERS_BUTTON.value,
                      )}
                    </Button>
                  </PopoverContainer>
                }
              >
                <Badge dot>
                  <Icon component={FilterSvg} onClick={() => setFilterVisible(!filterVisible)} />
                </Badge>
              </Popover>) : null}
            </>
          }
        />
        {!fetchingCategories && selectedView === 'view-search-template' && (
          <NoteText>
            {t(
              DESIGN_AREA_FLOW_BLOCK_TAB.TEMPLATES_FOUND_COUNT.key,
              DESIGN_AREA_FLOW_BLOCK_TAB.TEMPLATES_FOUND_COUNT.value,
              { templatesCount: searchedTemplates?.count },
            )}
          </NoteText>
        )}
      </TabSearchContainer>
    );
  };

  const renderLoader = (styles = {}) => (
    <LoaderContainer top={styles.top}>
      <Loader />
      <div className="loading-txt">{t(DESIGN_AREA_FLOW_BLOCK_TAB.LOADING_MORE_TEMPLATES_TEXT.key, DESIGN_AREA_FLOW_BLOCK_TAB.LOADING_MORE_TEMPLATES_TEXT.value)}</div>
    </LoaderContainer>
  );

  const disableModalVisibility = () => {
    setUpdateModalVisibility(false);
    setSelectedAction(null);
  };

  const style = { marginTop: selectedView === 'view-templates' ? "100px" : '125px' };
  if (isInteractiveDesign) {
    style.marginBottom = '0px';
  }

  return (

    <TabMenuContainer style={style}>
      <SearchNavWrapper className="hideSearch">
        <Tabs defaultActiveKey="usertemplate" onChange={handleTemplateType}>
          {!isInteractiveDesign && currentDesign === 'document' &&
            <TabPane tab={t(
              DESIGN_AREA_FLOW_BLOCK_TAB.REUSE_PAGE_TAB_TITLE.key,
              DESIGN_AREA_FLOW_BLOCK_TAB.REUSE_PAGE_TAB_TITLE.value,
            )} key="flow"></TabPane>
          }
          <TabPane tab={t(
            DESIGN_AREA_FLOW_BLOCK_TAB.REUSE_SECTION_TAB_TITLE.key,
            DESIGN_AREA_FLOW_BLOCK_TAB.REUSE_SECTION_TAB_TITLE.value,
          )} key="block"></TabPane>
          {ENTERPRISE_ENV && !isInteractiveDesign && currentDesign === 'document' ? (
            <TabPane
              tab={t(
                DESIGN_AREA_FLOW_BLOCK_TAB.REUSE_INSERTS_TITLE.key,
                DESIGN_AREA_FLOW_BLOCK_TAB.REUSE_INSERTS_TITLE.value,
              )}
              key="inserts"
            ></TabPane>
          ) : null}
        </Tabs>
        {renderSearchBar()}
      </SearchNavWrapper>
      {fetchingCategories && renderLoader()}
      <div>
        {!fetchingCategories && (
          <div onScroll={onScroll}>
            {!isLoading && categoryTemplates?.length === 0 && selectedTab !== 'inserts' && renderEmptyView()}
            {categoryTemplates?.length > 0 && renderTabBody()}
            {selectedTab === 'inserts' && allInserts?.length === 0 && renderEmptyView()}
            {selectedTab === 'inserts' && allInserts?.length > 0 && renderTabBody()}
          </div>
        )}
      </div>
      {selectedTab === 'inserts' ? <HelpGuideWrapper reusable={true}>
        <div className="help-container">
          <div className="help-action-btn">
            <UploadInserts onSuccess={onSuccess} />
          </div>
        </div>
      </HelpGuideWrapper> :
      (checkUserAccessRoles(['REUSABLECONTENTMANAGER']) && !isInteractiveDesign) ? <HelpGuideWrapper reusable={true}>
        <div className="help-container">
          <div
            className="help-action-btn"
            onClick={() => enableModalVisibility(selectedTab === 'flow' ? 'create-flow' : 'create-reusableBlock', null)}
          >
            <Icon type="plus" />{' '}
            {
              selectedTab === 'flow' ? t(
                DESIGN_AREA_FLOW_BLOCK_TAB.CREATE_NEW_REUSABLE_PAGES_BUTTON.key,
                DESIGN_AREA_FLOW_BLOCK_TAB.CREATE_NEW_REUSABLE_PAGES_BUTTON.value,
              )
                :
                t(
                  DESIGN_AREA_FLOW_BLOCK_TAB.CREATE_NEW_REUSABLE__SECTION_BUTTON.key,
                  DESIGN_AREA_FLOW_BLOCK_TAB.CREATE_NEW_REUSABLE__SECTION_BUTTON.value,
                )
            }
          </div>
        </div>
      </HelpGuideWrapper> : null}
      {!fetchingCategories && updateModalVisibility && selectedAction && renderModals()}
    </TabMenuContainer>
  );
};

export default withTranslation(NAMESPACES)(ComplexElementsTab);

